import ClassicUpgradeCollection from "../../../model/upgrade/classic/ClassicUpgradeCollection";
import { CountToPurchase } from "../../../model/upgrade/classic/CountToPurchase";
import Page from "../../framework/Page";
import View from "../../framework/View";

export default class CountToPurchaseView extends View {
    /**
     * @param {string} parentId
     * @param {ClassicUpgradeCollection} upgradeCollection
     */
    constructor(parentId, elementId, upgradeCollection) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {ClassicUpgradeCollection}
         */
        this.upgradeCollection = upgradeCollection;

        /**
         * @type {HTMLElement}
         */
        this.purchaseOneButton = null;
        /**
         * @type {HTMLElement}
         */
        this.purchaseFiveButton = null;
        /**
         * @type {HTMLElement}
         */
        this.purchaseTenButton = null;
        /**
         * @type {HTMLElement}
         */
        this.purchaseMaxButton = null;

        /**
         * @type {number}
         */
        this.displayedPurchaseCount = CountToPurchase.purchaseOne;

        this.setCurrentlyVisible(false);
        this.setViewVisible(true);
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'grid';
    }


    /**
     * @override
     */
    initializeView() {
        super.initializeView();

        // The upgrade view is dynamically created.
        const id = this.getElementId();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('CountToPurchaseView.initializeView() No element found! id=' + id);
            return;
        }

        const containerElement = Page.createElement('div', parent, id, 'purchase-count-button-container');

        // Create the buttons
        this.purchaseOneButton = Page.createElement('div', containerElement, id + '_one', 'purchase-count-button-selected');
        this.purchaseFiveButton = Page.createElement('div', containerElement, id + '_five', 'purchase-count-button');
        this.purchaseTenButton = Page.createElement('div', containerElement, id + '_ten', 'purchase-count-button');
        this.purchaseMaxButton = Page.createElement('div', containerElement, id + '_max', 'purchase-count-button');

        this.purchaseOneButton.innerHTML = '1';
        this.purchaseFiveButton.innerHTML = '5';
        this.purchaseTenButton.innerHTML = '10';
        this.purchaseMaxButton.innerHTML = 'Max';

        const thisRef = this;
        
        this.purchaseOneButton.onclick = function () {
            thisRef.upgradeCollection.setCountToPurchase(CountToPurchase.purchaseOne);
        };
        this.purchaseFiveButton.onclick = function () {
            thisRef.upgradeCollection.setCountToPurchase(CountToPurchase.purchaseFive);
        };
        this.purchaseTenButton.onclick = function () {
            thisRef.upgradeCollection.setCountToPurchase(CountToPurchase.purchaseTen);
        };
        this.purchaseMaxButton.onclick = function () {
            thisRef.upgradeCollection.setCountToPurchase(CountToPurchase.purchaseMax);
        };
    }

    /**
     * @override
     */
    updateViewContents() {
        // set the style class of the selected button.
        const countToPurchase = this.upgradeCollection.countToPurchase;

        if (this.displayedPurchaseCount === countToPurchase) {
            return;
        }

        ////////////////////////////////
        // De-select old setting
        ////////////////////////////////

        if (this.displayedPurchaseCount === CountToPurchase.purchaseOne) {
            this.purchaseOneButton.className = 'purchase-count-button';
        }
        else if (this.displayedPurchaseCount === CountToPurchase.purchaseFive) {
            this.purchaseFiveButton.className = 'purchase-count-button';
        }
        else if (this.displayedPurchaseCount === CountToPurchase.purchaseTen) {
            this.purchaseTenButton.className = 'purchase-count-button';
        }
        else if (this.displayedPurchaseCount === CountToPurchase.purchaseMax) {
            this.purchaseMaxButton.className = 'purchase-count-button';
        }

        ////////////////////////////////
        // Select new setting
        ////////////////////////////////

        if (countToPurchase === CountToPurchase.purchaseOne) {
            this.purchaseOneButton.className = 'purchase-count-button-selected';
        }
        else if (countToPurchase === CountToPurchase.purchaseFive) {
            this.purchaseFiveButton.className = 'purchase-count-button-selected';
        }
        else if (countToPurchase === CountToPurchase.purchaseTen) {
            this.purchaseTenButton.className = 'purchase-count-button-selected';
        }
        else if (countToPurchase === CountToPurchase.purchaseMax) {
            this.purchaseMaxButton.className = 'purchase-count-button-selected';
        }

        this.displayedPurchaseCount = countToPurchase;
    }

}